<script setup lang="ts">
import { Moon, Sun } from 'lucide-vue-next'

defineProps<{ dark: boolean }>()
const emit = defineEmits<{ toggle: [] }>()
</script>

<template>
  <button type="button" class="ck-theme-toggle" :aria-label="dark ? 'Tema claro' : 'Tema escuro'" :title="dark ? 'Tema claro' : 'Tema escuro'" @click="emit('toggle')">
    <Sun v-if="dark" :size="18" />
    <Moon v-else :size="18" />
  </button>
</template>

<style scoped>
.ck-theme-toggle { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border: 1px solid var(--color-border); border-radius: var(--radius-md); background: var(--color-surface); color: var(--color-text-muted); cursor: pointer; }
.ck-theme-toggle:hover, .ck-theme-toggle:focus-visible { color: var(--color-accent); border-color: var(--color-accent); }
</style>
